// extracted by mini-css-extract-plugin
export default {"productGrid":"RZ-z","centerLink":"SZ-z","productSection":"TZ-z","item":"UZ-z","ctaButton":"VZ-z"};